import clsx from "clsx";
import { type FC } from "react";

import { COURSE_GROUPING_ID_QUERY_PARAM, COURSE_ID_QUERY_PARAM } from "components/constants";
import { CourseType } from "components/server-types";
import { DragAndDrop, DraggableItemType } from "mds/components/DragAndDrop";
import { ListItem } from "mds/components/ListItem";
import { useQueryParamsManager } from "utils/routing";
import { withQueryParams } from "utils/urls";

const COURSE_EVENT_PREFIX = "Home - Course Catalog / ";

type CourseNavListItemProps = {
  className?: string;
  course: CourseType;
  isSelected: boolean;
  dropIndex?: number;
  onDropItem?: (item: CourseType) => void;
  onMoveLocally?: (item: DraggableItemType, toIndex: number, dropContainerId: string) => void;
};

export const CourseNavListItem: FC<CourseNavListItemProps> = ({
  course,
  className,
  isSelected,
  dropIndex,
  onDropItem,
  onMoveLocally,
}) => {
  const { setQueryParams } = useQueryParamsManager();

  return (
    <DragAndDrop
      // draggable={canEdit}
      dragItemKind="course"
      dropContainerId="course"
      dropIndex={dropIndex}
      // droppable={canEdit}
      item={course}
      onDraggedItemHover={onMoveLocally}
      onDropItem={onDropItem}
    >
      <ListItem
        className={clsx("my-1 min-w-12 justify-between", className)}
        eventName={`${COURSE_EVENT_PREFIX}course code selected`}
        eventProperties={{ course: course.title }}
        isSelected={isSelected}
        label={course.title}
        to={withQueryParams("", {
          [COURSE_ID_QUERY_PARAM]: course.id,
          [COURSE_GROUPING_ID_QUERY_PARAM]: null,
        })}
        onClick={() => {
          setQueryParams({
            [COURSE_ID_QUERY_PARAM]: course.id,
            [COURSE_GROUPING_ID_QUERY_PARAM]: null,
          });
        }}
      >
        <div className="flex w-full min-w-12 items-center justify-between">
          <h3 className="body-s my-1 w-full min-w-12 cursor-pointer truncate font-medium">
            {course.title}
          </h3>
        </div>
      </ListItem>
    </DragAndDrop>
  );
};
